import React from 'react';
import {
  Box,
  LinearProgress,
  List,
  ListItem,
  ListItemText,
  Paper,
  Stack,
  Typography,
} from '@mui/material';

const CohortExecutionPanel = ({
  isExecuting,
  executionTargetNodeId,
  executionMode,
  executionProgress,
  showExecutionLog,
  executionLogs,
}) => (
  <>
    <Box sx={{ mt: 1.5 }} role="status" aria-live="polite">
      <Stack direction={{ xs: 'column', md: 'row' }} spacing={1.5} alignItems={{ xs: 'flex-start', md: 'center' }}>
        <Typography variant="caption" color={isExecuting ? 'warning.main' : 'text.secondary'}>
          {isExecuting
            ? executionTargetNodeId
              ? executionMode === 'breakpoint'
                ? `Executing to breakpoint ${executionTargetNodeId}...`
                : `Executing to node ${executionTargetNodeId}...`
              : 'Executing full graph...'
            : 'Execution idle'}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          Progress: <strong>{executionProgress}%</strong>
        </Typography>
      </Stack>
      <LinearProgress
        variant="determinate"
        value={executionProgress}
        sx={{ mt: 0.75, height: 6, borderRadius: 99 }}
      />
    </Box>

    {showExecutionLog ? (
      <Box sx={{ mt: 1.5 }}>
        <Typography variant="caption" color="text.secondary">
          Execution log (shown on request)
        </Typography>
        <Paper variant="outlined" sx={{ mt: 0.5, maxHeight: 160, overflow: 'auto' }}>
          {executionLogs.length > 0 ? (
            <List dense disablePadding>
              {executionLogs.map((entry, index) => (
                <ListItem key={`${index}-${entry}`} sx={{ py: 0.35, px: 1 }}>
                  <ListItemText
                    primaryTypographyProps={{ variant: 'caption', sx: { fontFamily: 'monospace' } }}
                    primary={entry}
                  />
                </ListItem>
              ))}
            </List>
          ) : (
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', p: 1 }}>
              No execution entries yet.
            </Typography>
          )}
        </Paper>
      </Box>
    ) : null}
  </>
);

export default CohortExecutionPanel;

